mobileSize = 1024;

$.fn.isInViewport = function() {
	const elementTop = $(this).offset().top;
	const elementBottom = elementTop + $(this).outerHeight();

	const viewportTop = $(window).scrollTop();
	const viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

// Animations
if ($('body').hasClass('homepage')) {
  $(window).on('load scroll', function() {
    if ($('#seoWidget').isInViewport()) {
      $('.stingray-1')
        .addClass('animate__animated animate__fadeInLeft')
        .css('opacity', '1');
    }
  
    if ($('#membership').isInViewport()) {
      $('#membership .card-content')
        .addClass('animate__animated animate__fadeInLeft')
        .css('opacity', '1');
      $('#membership .image-container img')
        .addClass('animate__animated animate__fadeInRight')
        .css('opacity', '1');
    }
  
    if ($('#circularWidget').isInViewport()) {
      $('.dolphin')
        .addClass('animate__animated animate__fadeInLeft')
        .css('opacity', '1');
    }
  
    if ($('.tier-nine').isInViewport()) {
      $('.stingray-2')
        .addClass('animate__animated animate__fadeInRight')
        .css('opacity', '1');
    }
  });
}

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1025) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1024) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Email Signup
  $('.emailSignup .emailSignupText').text('Subscribe to our newsletter for up to date information, promotions and specials.');
  $('.emailSignup .emailSubmitButton')
    .appendTo('.emailInputField')
    .text('Subscribe');

  // Copyright
  $('<span>A Registered 501(c)(3) not for profit corporation. EIN: 81-4974774. </span>').appendTo('.copyright');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Hero Images
  const heroHTML = '<div class="hero-wrapper" style="background-image: url()"></div>';

  if ( !$('body').hasClass('homepage') ) {
    $(heroHTML).prependTo('.wrapper');
  }

  let dynamicHero = () => {
    const image = $('.entityContainer .entityContainerRow.rowIndex-1').find('.imageModule-single img').attr('data-src');
    const title = $('.entityContainer .entityContainerRow.rowIndex-1').find('.dynamicPageTitle');
    const imageSrc = image.replace(/(?=[() ])/g, '\\');
    
    $('.hero-wrapper').css('background-image', 'url(' + imageSrc + ')');
    $('.hero-wrapper').append(title);
  }

  let staticHero = () => {
    $('.hero-wrapper').css('background-image', 'url(' + `${FULLCLIENTTHEMEPATH}images/underwater.jpg` + ')');
    const title = $('.entityContainer .entityContainerRow.rowIndex-1').find('.dynamicPageTitle');
    $('.hero-wrapper').append(title);
  }

  if ($('body').hasClass('custom')) {
    $('body').removeClass('default');
    dynamicHero();
  } 
  
  if ($('body').hasClass('default')) {
    staticHero();
  }

  if (~window.location.pathname.indexOf('events')) {
    const eventTitle = $('.content h1');
    $('.hero-wrapper').append(eventTitle);
    eventTitle.addClass('event-title');
  }

  // Circular Images
  $('.TextMediaModule').each(function() {
    const moduleTitle = $(this).find('.moduleTitle span');
    const imgWrapper = $(this).find('.media-container.single-photo');
  
    if (moduleTitle.text() == 'C' || moduleTitle.text() == 'c') {
      imgWrapper.addClass('round');
      moduleTitle.hide();
    }
  });
  
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');

  $('.event-id-0 .hero-wrapper .event-title').text('Event Calendar');
});